
export default {
  name: 'LoadingSpinner',
}
